import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AlertService, CommonService } from "src/app/services";
import { StorageService } from "src/app/services/storage.service";
import { CommonStore, PatientStore } from "src/app/store";
import { DrugBucketUtil } from "src/app/utils/drug-bucket.util";
import { FormatsUtil } from "src/app/utils/formats.util";
import { CommonUtil } from 'src/app/utils';
import { environment } from "src/environments/environment";
import { MsgConfig } from "src/app/app.messages";
import * as moment from 'moment';

@Component({
    selector: "app-rx-prescriber-card",
    templateUrl: "./rx-prescriber-card.component.html",
    styles: [],
    standalone: false
})
export class RxPrescriberCardComponent implements OnInit, OnDestroy {
    PrescAddress: any;
    prescriberInfo: any;
    hasPatientHistory: boolean;
    drugInfo: any;
    isFromErx: any;
    unsubscribe$: Subject<void> = new Subject();
    Is340BStatus:boolean;
    @Input() rxFG: any;
    @Input() IsFromErxRequest: any;
    @Input() SelectedAddressId:any
    patientInfo: any;
    @Input()
    set PrescriberInfo(pi: any) {
        this.prescriberInfo = pi;
        this.displaySelectedAddrrss(false);
    }

    @Input()
    set HasPatientHistoryVisb(ph: boolean) {
        this.hasPatientHistory = ph;
    } 
    @Input()
    set DrungInfo(di: boolean) {
        this.drugInfo = di;
    }

    @Input()
    set IsFromERx(ifr: any) {
        this.isFromErx = ifr;
    }
    get Prescriber(): FormGroup {
        return this.rxFG?.get("Prescriber") as FormGroup;
    }
    @Input() RxPatientInfo;

    isIvrEnabled = environment.isIvrEnabled;

    constructor(private _commonStore: CommonStore, private _drugBuckUtil:DrugBucketUtil,private _commServ: CommonService, public _formatsUtil: FormatsUtil, private _comnUtil: CommonUtil, private _alerSer: AlertService, private _patientStore: PatientStore, private _storageService: StorageService) {}    
    ngOnInit() {
       this._commonStore._clinicalAddress$
       .pipe(takeUntil(this.unsubscribe$))
       .subscribe(resp => {
            if (resp && this.prescriberInfo) {
                this.prescriberInfo.PrescriberAddresses = resp;
                this.displaySelectedAddrrss(true);
            }
       })
        this.isIvrEnabled = environment.isIvrEnabled && this._storageService.get("IvrGUIDDetails") ? true : false;
        this.patientInfo = this._patientStore.patientEditInfo$["source"]["value"];
    }
    async displaySelectedAddrrss(value){
      const preSetting =  await this._drugBuckUtil.checkPrescriber340OrNot(this.Prescriber);
      const settings = await this._commServ.getSetttingValue("ThreeFourtyBSettings", "340B_PHARM") === "1";
      this.Is340BStatus = (preSetting && settings)? true : false;
      let rxtypecheck   = (value ? (this.rxFG && this.rxFG.value && this.rxFG.value.rxType && (this.rxFG.value.rxType == "nr" || this.rxFG.value.rxType == "er" || this.rxFG.value.rxType == "rf") ? true: false) : true);
        if(rxtypecheck && this.prescriberInfo && this.prescriberInfo.PrescriberAddresses && this.prescriberInfo.PrescriberAddresses.length){
                if (this.prescriberInfo.PrescriberAddresses.length > 1) {
                    this.prescriberInfo.PrescriberAddresses.map(value => {
                        if(this.rxFG && this.rxFG.controls && this.rxFG.controls.Prescription &&  this.rxFG.controls.Prescription.value && (value["Id"] == this.rxFG.controls.Prescription.value.PrescriberAddressId)){
                            this.PrescAddress = value;
                        }
                    });
                    if(!this.PrescAddress){
                        this.prescriberInfo.PrescriberAddresses.find(value=>{
                            if(value["Id"] == this.prescriberInfo.primeAddressId){
                                this.PrescAddress = value;
                            }
                        })
                    }
                } else {
                    this.PrescAddress =  this.prescriberInfo.PrescriberAddresses["0"];
                }
            }
          
        }

        async clickToCallOutBond(mobile) {
            let resp;
            let callRequest = this._comnUtil.clickToOutBondcall(mobile);
            if(callRequest && mobile && this.isIvrEnabled) {
                if(this.RxPatientInfo) {
                    this.prescriberInfo['patientInfo'] = this.RxPatientInfo?.lastname ? { name: this.RxPatientInfo?.lastname + ', ' + this.RxPatientInfo?.firstname, id: this.RxPatientInfo?.patientid, dob: this.RxPatientInfo?.dob, phoneNumber: (this.RxPatientInfo?.mobile || this.RxPatientInfo?.telephone || this.RxPatientInfo?.worknumber), gender: this.RxPatientInfo?.gender, addressLine1: this.RxPatientInfo?.address1, state: this.RxPatientInfo?.state, city: this.RxPatientInfo?.city, zipCode: this.RxPatientInfo?.zipcode } : null;
                } else {
                    this.prescriberInfo['patientInfo'] = this.patientInfo ? { name:this.patientInfo?.Person?.LastName + ', ' + this.patientInfo?.Person?.FirstName, id:this.patientInfo?.Person?.Id, dob:moment(this.patientInfo?.Person?.BirthDt).format(MsgConfig.DATE_FORMAT), phoneNumber:(this.patientInfo?.Phones[0]?.xPhone || this.patientInfo?.Phones[1]?.xPhone || this.patientInfo?.Phones[2]?.xPhone), gender:(this.patientInfo?.Person?.GenderId === 2 ? 'Male' :  this.patientInfo?.Person?.GenderId === 3 ? 'Female' : '--'), addressLine1:this.patientInfo?.Addresses?.AddressLine1, state:this.patientInfo?.Addresses?.StateName, city:this.patientInfo?.Addresses?.CityName, zipCode:this.patientInfo?.Addresses?.ZipCode } : null;
                }
                if(callRequest?.ivrVendor === 1) {
                    resp = await this._commServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                    if(resp) this._comnUtil.openCallLogPopup(mobile,this.prescriberInfo,'Prescriber');
                    else { this._alerSer.error(MsgConfig.IVR_Call_Error); this._commServ._isCallOngoing$.next(null); }
                } else if(callRequest?.ivrVendor === 2) {
                    this._commServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                    this._comnUtil.openCallLogPopup(mobile,this.prescriberInfo,'Prescriber');
                }
            }        
        }

        ngOnDestroy() {
            this.unsubscribe$.next();
            this.unsubscribe$.complete();

        }
}
